import { render, staticRenderFns } from "./BillQuickFoodOrder.vue?vue&type=template&id=85eecf04&scoped=true"
import script from "./BillQuickFoodOrder.vue?vue&type=script&lang=js"
export * from "./BillQuickFoodOrder.vue?vue&type=script&lang=js"
import style0 from "./BillQuickFoodOrder.vue?vue&type=style&index=0&id=85eecf04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85eecf04",
  null
  
)

export default component.exports